import { render, staticRenderFns } from "./FilePathMapping.vue?vue&type=template&id=3b03fff7&scoped=true&"
import script from "./FilePathMapping.vue?vue&type=script&lang=ts&"
export * from "./FilePathMapping.vue?vue&type=script&lang=ts&"
import style0 from "./FilePathMapping.vue?vue&type=style&index=0&id=3b03fff7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b03fff7",
  null
  
)

export default component.exports